import { render, staticRenderFns } from "./ProductInfoDefault.vue?vue&type=template&id=5b72d383&"
import script from "./ProductInfoDefault.vue?vue&type=script&lang=js&"
export * from "./ProductInfoDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports